import { render, staticRenderFns } from "./disabled-message.vue?vue&type=template&id=3a991994&"
import script from "./disabled-message.vue?vue&type=script&lang=js&"
export * from "./disabled-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports